import React, { useState } from "react";

import { Modal } from "antd";
import api from "../../../../services/api";

export const RelatorioDevedores = ({ history }) => {
  const [isLoading, setLoading] = useState(false);

  const handleOk = () => {
    setLoading(true);

    api
      .get("/contratos/reports/devedores/")
      .then(({ data }) => {
        if (!data.report) {
          Modal.error({
            content: "Falha ao obter a url do relatório gerado."
          });
          return;
        }

        const url = data.report;

        Modal.success({
          content: "Relatório gerado com sucesso!"
        });

        window.open(url);
      })
      .catch(err => {
        console.error(err);

        Modal.error({
          content: "Ocorreu um erro ao gerar relatório."
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => history.goBack();

  return (
    <Modal
      title="Relatório de Devedores"
      visible
      onOk={handleOk}
      cancelText="Cancelar"
      onCancel={handleCancel}
      okText="Gerar"
      confirmLoading={isLoading}
    >
      <strong>Clique em "Gerar" para extraír o relatório de devedores.</strong>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/Relatorios/Devedores/index.jsx